import {
  DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_BEGIN,
  DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_SUCCESS,
  DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_FAILURE,
  DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function getSchemaForDirectusCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_BEGIN,
    });
    const { projectId, version, collectionName } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/directus/get-schema/${collectionName}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetSchemaForDirectusCollectionError() {
  return {
    type: DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_BEGIN:
      return {
        ...state,
        getSchemaForDirectusCollectionPending: true,
        getSchemaForDirectusCollectionError: null,
      };

    case DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_SUCCESS:
      return {
        ...state,
        getSchemaForDirectusCollectionPending: false,
        getSchemaForDirectusCollectionError: null,
        schemaForDirectus: action.data,
      };

    case DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_FAILURE:
      return {
        ...state,
        getSchemaForDirectusCollectionPending: false,
        getSchemaForDirectusCollectionError: action.data.error,
      };

    case DATA_CONNECTOR_GET_SCHEMA_FOR_DIRECTUS_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        getSchemaForDirectusCollectionError: null,
      };

    default:
      return state;
  }
}
